/**
 * Comments plan 3b (spec 2026-10-18-comments-design Rev. 3): files on a comment. Same limits as the server
 * (functions commentFileUpload.ts); the type follows the extension there too.
 */
export const FILE_TYPES = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};
export const FILE_MAX = 20 * 1024 * 1024;
export const FILES_PER_POST = 5;
export const ACCEPT = Object.keys(FILE_TYPES).map((e) => `.${e}`).join(',');

export function typeFor(name) {
  const m = /\.([a-z0-9]+)$/i.exec(name || '');
  return (m && FILE_TYPES[m[1].toLowerCase()]) || null;
}

/** The files that may go up, and one message per refused one (locale key + file name). */
export function checkFiles(files, already) {
  const ok = [];
  const errors = [];
  let room = FILES_PER_POST - already;
  files.forEach((f) => {
    if (!typeFor(f.name)) errors.push({ key: 'webmag.comments.fileType', name: f.name });
    else if (f.size > FILE_MAX) errors.push({ key: 'webmag.comments.fileTooBig', name: f.name });
    else if (room > 0) {
      ok.push(f);
      room -= 1;
    } else if (!errors.some((e) => e.key === 'webmag.comments.fileCount')) errors.push({ key: 'webmag.comments.fileCount', name: '' });
  });
  return { ok, errors };
}

export const isImage = (type) => /^image\//.test(type || '');
